export default "__VITE_ASSET__C6B0ua03__"